import { CONSOLE_PATHS } from "@sagot/constants";
import type { ReactElement } from "react";
import { RequirePermission } from "../pages/forbidden-page";
import { ActionsPage } from "./build/actions/actions-page";
import { AgentSettingsPage } from "./build/agent-settings/agent-settings-page";
import { AgentsPage } from "./build/agents/agents-page";
import { EvaluationsPage } from "./build/evaluations/evaluations-page";
import { PlaygroundPage } from "./build/playground/playground-page";

/** Screens owned by the "build" feature group, keyed by CONSOLE_PATHS value. */
export const buildScreens: Readonly<Record<string, ReactElement>> = {
  [CONSOLE_PATHS.agents]: (
    <RequirePermission permission="agents.view">
      <AgentsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.agentSettings]: (
    <RequirePermission permission="agents.view" mode="agent">
      <AgentSettingsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.playground]: (
    <RequirePermission permission="playground.use" mode="agent">
      <PlaygroundPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.actions]: (
    <RequirePermission permission="actions.view" mode="agent">
      <ActionsPage />
    </RequirePermission>
  ),
  [CONSOLE_PATHS.evaluations]: (
    <RequirePermission permission="evaluations.view" mode="agent">
      <EvaluationsPage />
    </RequirePermission>
  ),
};
